import { render, staticRenderFns } from "./myPhase.vue?vue&type=template&id=0e18a50c&scoped=true"
import script from "./myPhase.vue?vue&type=script&lang=js"
export * from "./myPhase.vue?vue&type=script&lang=js"
import style0 from "./myPhase.vue?vue&type=style&index=0&id=0e18a50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e18a50c",
  null
  
)

export default component.exports